import { CSSProperties } from 'react';
import { GoBackView } from '@vivli/shared/views';

const containerStyle: CSSProperties = {
    padding: '10px 20px',
    position: 'relative',
    background: 'white',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px, rgba(0, 0, 0, 0.1) 0px 1px 3px',
    zIndex: 101,
    wordBreak: 'break-all',
    display: 'grid',
    gridTemplateColumns: '1fr auto',
};

const leftHeaderStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: '1em',
};

const titleStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};

const titleContainerStyle: CSSProperties = {
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '5px',
};

const subTitleStyle: CSSProperties = {
    fontSize: '14px',
    color: '#666',
};

interface PageHeaderProps {
    children?: any;
    title?: string;
    subTitle?: string;
    backButtonText?: string;
    onBackClick?: () => void;
}

export const PageHeaderView = ({ children, title, subTitle, backButtonText, onBackClick }: PageHeaderProps) => {
    return (
        <div style={containerStyle} className="do-not-print">
            <div style={leftHeaderStyle}>
                <GoBackView textToShow={backButtonText} onButtonClick={onBackClick} />
                <div style={titleContainerStyle}>
                    {title && <div style={titleStyle}>{title}</div>}
                    {subTitle && <div style={subTitleStyle}>{subTitle}</div>}
                </div>
            </div>

            {children}
        </div>
    );
};
